import { render, staticRenderFns } from "./monitor-center-alert-bind.vue?vue&type=template&id=74764068&scoped=true"
import script from "./monitor-center-alert-bind.vue?vue&type=script&lang=js"
export * from "./monitor-center-alert-bind.vue?vue&type=script&lang=js"
import style0 from "./monitor-center-alert-bind.vue?vue&type=style&index=0&id=74764068&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74764068",
  null
  
)

export default component.exports